import enTranslations from '../../translations/en.json';
import esTranslations from '../../translations/es.json';

export function initialize(appInstance: any) {
  const intl = appInstance.lookup('service:intl');

  // Load translations
  intl.addTranslations('en', enTranslations);
  intl.addTranslations('es', esTranslations);
}

export default {
  name: 'load-translations',
  initialize
};

